import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useEventoNuevo } from './hooks/useEventoNuevo';

import { useForm, useFormValidation } from '../../../hooks';

import { PrimaryButton, LightButton, DateInput, TimeInput, TextAreaInput, TextInput, Forbidden } from '../../../components';

import { eliminarUndefined } from '../../../helpers/eliminarUndefined';

import styles from '../Modals.module.css';

export const CrearEventoAgendaModal = ({ data, hide }) => {

    const { permisos } = useSelector(state => state.auth);

    const [inactivoFlag, setInactivoFlag] = useState(false);
    const [horarioFlag, setHorarioFlag] = useState(false);
    const [empalmadaFlag, setEmpalmadaFlag] = useState(false);

    const activeInactivoFlag = () => {
        setInactivoFlag(true);
    }

    const activeHorarioFlag = () => {
        setHorarioFlag(true);
    }

    const activeEmpalmadaFlag = () => {
        setEmpalmadaFlag(true);
    }

    const { createEventoMutation: { mutate: createEvento } } = useEventoNuevo();

    const { nombre, fechaInicio, horaInicio, fechaFin, horaFin, comentario, onInputChange, onResetForm } = useForm({ nombre: '', fechaInicio: (typeof data !== 'undefined' && typeof data.fechaInicio !== 'undefined') ? data.fechaInicio : '', horaInicio: (typeof data !== 'undefined' && typeof data.horaInicio !== 'undefined') ? data.horaInicio : '', fechaFin: (typeof data !== 'undefined' && typeof data.fechaFin !== 'undefined') ? data.fechaFin : '', horaFin: (typeof data !== 'undefined' && typeof data.horaFin !== 'undefined') ? data.horaFin : '', comentario: '' });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation, onResetValidation } = useFormValidation([{field: 'nombre', default: true}, {field: 'fechaInicio', default: (typeof data !== 'undefined' && typeof data.fechaInicio !== 'undefined') ? true : false}, {field: 'horaInicio', default: (typeof data !== 'undefined' && typeof data.horaInicio !== 'undefined') ? true : false}, {field: 'fechaFin', default: (typeof data !== 'undefined' && typeof data.fechaFin !== 'undefined') ? true : false}, {field: 'horaFin', default: (typeof data !== 'undefined' && typeof data.horaFin !== 'undefined') ? true : false}, {field: 'comentario', default: true}]);

    const handleInputChange = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChange(e);
    }

    const handleSuccessSubmit = () => {
        onResetForm();
        onResetValidation();
    }

    const onSubmit = async ( event ) => {
        event.preventDefault();

        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            createEvento({ data: eliminarUndefined({ nombre, fechaInicio, horaInicio, fechaFin, horaFin, comentario, inactivoConfirmacion: inactivoFlag, horarioConfirmacion: horarioFlag, empalmadaConfirmacion: empalmadaFlag }, { paciente: undefined, comentario: undefined }), onSuccess: handleSuccessSubmit, onComplete: hide, onInactivo: activeInactivoFlag, onHorario: activeHorarioFlag, onEmpalmada: activeEmpalmadaFlag});
        }else{
            startFormValidation();
        }

    }

    return (permisos.eventoCreate) ? (
        <div>
            <form onSubmit={ onSubmit }>
                <div className="row mb-3">
                    <div className="col">
                        <div className={styles.modalHeader}>Evento nuevo</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <TextInput
                            formFieldStatus={ formFields['nombre'].status }
                            label="Evento"
                            name="nombre"
                            onChange={ onInputChange }
                            required={ true }
                            requiredIndicator={ true }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ nombre }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-3">
                        <DateInput
                            formFieldStatus={ formFields['fechaInicio'].status }
                            label="Desde"
                            name="fechaInicio"
                            onChange={ handleInputChange }
                            required={ true }
                            requiredIndicator={ true }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ fechaInicio }
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <TimeInput
                            formFieldStatus={ formFields['horaInicio'].status }
                            label=""
                            name="horaInicio"
                            onChange={ handleInputChange }
                            required={ true }
                            requiredIndicator={ false }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ horaInicio }
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <DateInput
                            formFieldStatus={ formFields['fechaFin'].status }
                            label="Hasta"
                            name="fechaFin"
                            onChange={ handleInputChange }
                            required={ true }
                            requiredIndicator={ true }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ fechaFin }
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <TimeInput
                            formFieldStatus={ formFields['horaFin'].status }
                            label=""
                            name="horaFin"
                            onChange={ handleInputChange }
                            required={ true }
                            requiredIndicator={ false }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ horaFin }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <TextAreaInput
                            formFieldStatus={ formFields['comentario'].status }
                            label="Comentario"
                            name="comentario"
                            onChange={ handleInputChange }
                            required={ false }
                            requiredIndicator={ false }
                            setFormFieldValidation={ setFormFieldValidation }
                            value={ comentario }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        {(inactivoFlag) && <p className={styles.helperErrorText}>La fecha seleccionada esta marcada como día inactivo en la configuración del consultorio. ¿Deseas continuar igualmente?</p>}
                        {(horarioFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado esta fuera del horario configurado para el consultorio. ¿Deseas continuar igualmente?</p>}
                        {(empalmadaFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado se empalma con otra cita previamente agendada. ¿Deseas continuar igualmente?</p>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-6">
                        <LightButton
                            block={true}
                            icon="X"
                            marginTop={false}
                            onClick={ hide }
                            text="Cancelar"
                            type="button"
                        />
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-6'>
                        <PrimaryButton
                            block={true}
                            disabled={formValidationStatus === 'checking'}
                            icon="Check"
                            marginTop={false}
                            text={(inactivoFlag || horarioFlag || empalmadaFlag) ? "Confirmar" : "Crear"}
                            type="submit"
                        />
                    </div>
                </div>
            </form>
        </div>
    ) : <Forbidden />
}

CrearEventoAgendaModal.propTypes = {
  data: PropTypes.object,
  hide: PropTypes.func.isRequired,
}